import { NavLink } from 'react-router-dom';

import { navigationLinks } from '~/shared/config/navigation-links';
import { LinkTypes } from '~/shared/model/link-types.ts';

type NavLinkProperties = {
  linkType: LinkTypes;
  onLinkClick: () => void;
};

export function NavLinks({ linkType, onLinkClick }: NavLinkProperties) {
  const links = navigationLinks.get(linkType);

  return (
    links &&
    links.map((link) => {
      return (
        <NavLink
          to={link.to}
          className="text-muted-foreground"
          key={link.to}
          onClick={onLinkClick}
        >
          {link.linkText}
        </NavLink>
      );
    })
  );
}
